import { Injectable } from '@angular/core';
import { TDOWNLOAD_LISTING_DATA_PAYLOAD, TExcelContext } from '@monorepo/types';
import { TUploadResponseDTO } from '@monorepo/services';
import { Store } from '@ngrx/store';
import * as TExcelManagementActions from './excel-management.actions';
import { TMachineMaintenanceState } from '../reducers';

@Injectable({
  providedIn: 'root',
})
export class ExcelManagementFacade {
  constructor(private store: Store<TMachineMaintenanceState>) {}

  downloadSampleTemplate(excelContext: TExcelContext) {
    this.store.dispatch(new TExcelManagementActions.DownloadExcel(excelContext));
  }

  downloadErrorTemplate(
    errorKey: Exclude<TUploadResponseDTO['errorFileKeyOpt'], undefined>,
    excelContext: TExcelContext,
  ) {
    this.store.dispatch(new TExcelManagementActions.DownloadErrorExcel({ errorKey, excelContext }));
  }

  uploadExcel(file: File, excelContext: TExcelContext) {
    this.store.dispatch(new TExcelManagementActions.UploadExcel({ file, excelContext }));
  }

  downloadListingDataExcel(excelContext: TExcelContext, payload: TDOWNLOAD_LISTING_DATA_PAYLOAD) {
    this.store.dispatch(new TExcelManagementActions.DownloadListingDataExcel(excelContext, payload));
  }
}
